---
en:
  labels:
    apply: Apply
    clear: Clear
    labels: Labels
